import { Language } from '@ads/front-core/api'

export const POLAND_NAME = 'Poland'
export const POLAND_SYMBOL: Language = 'PL'

export const ENGLISH_SYMBOL: Language = 'EN'
